import { create } from 'zustand'
import AsyncStorage from '@react-native-async-storage/async-storage'

const STORAGE_KEY = '@pinnedPosts:expanded'

const usePinnedPostsStore = create((set, get) => ({
    expandedPostIDs: [],

    hydrate: async () => {
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY)
            if(stored){
                set({ expandedPostIDs: JSON.parse(stored) })
            }
        } catch {
            // silently fail
        }
    },

    toggleExpanded: async (postID) => {
        const { expandedPostIDs } = get()
        const isExpanded = expandedPostIDs.includes(postID)
        const newExpanded = isExpanded
            ? expandedPostIDs.filter(id => id !== postID)
            : [...expandedPostIDs, postID]
        set({ expandedPostIDs: newExpanded })
        try {
            await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(newExpanded))
        } catch {
            // silently fail
        }
    },

    isExpanded: (postID) => get().expandedPostIDs.includes(postID),
}))

export default usePinnedPostsStore
